
<div class="row chatgraphs-dadhboard">

  <div class="col-md-4 col-xl-4">
    <div class="card-box tilebox-one div-canvas-size">
      <h4 style="text-align: center;">Device Model Details</h4>
      <canvas baseChart
              [data]="dataIso"
              [labels]="labelsIso"
              [chartType]="chartTypeIso"
              [options]="optionsIso"
              [colors]="colorsIso"
              class="canvas-size">
      </canvas>
    </div>
  </div>

  <div class="col-md-4 col-xl-4">
    <div class="card-box tilebox-one div-canvas-size">
      <h4 style="text-align: center;">Traded and Untraded</h4>
      <canvas baseChart
              [data]="dataTrand"
              [labels]="labelsTrand"
              [chartType]="chartTypeTrand"
              [options]="optionsTrand"
              [colors]="colorsTrand"
              class="canvas-size">
      </canvas>
    </div>
  </div>

  <div class="col-md-4 col-xl-4">
    <div class="card-box tilebox-one div-canvas-size">
      <h4 style="text-align: center;">Active vs Deactivated TIDs</h4>
      <canvas baseChart
          [datasets]="dataSetActivation"
          [labels]="labelsActivation"
          [options]="optionsActivation"
          [chartType]="chartTypeActivation"
          [legend]="legendActivation"
          [colors]="colorsActivation"
          class="canvas-size">
      </canvas>
    </div>
  </div>

  <div class="row col-md-12 col-xl-12" style="margin:0;padding:0;">
    <div class=" col-md-6 col-xl-6">
      <div class="col-12 card-box tilebox-one">
        <div class="col-md-12 col-xl-12">
          <label for="typeTrans" style="margin-right: 15px; cursor: pointer;">
            <input type="radio" id="typeTrans" name="selectedType" value="trans" [(ngModel)]="selectedType" (change)="onChangeBillType($event)" style="width:30px;">
            Transaction Count
          </label>

          <label for="typeSales" style="cursor: pointer;">
            <input type="radio" id="typeSales" name="selectedType" value="sales" [(ngModel)]="selectedType" (change)="onChangeBillType($event)" style="width: 30px;">
            Transaction Amount
          </label>
        </div>

        <div class="col-md-12 col-xl-12">
          <h4 style="text-align: center;"> {{trasactionLabel}}</h4>

          <canvas baseChart
                  [datasets]="dataSetTransaction"
                  [labels]="labelsTrasaction"
                  [options]="optionsTrasaction"
                  [chartType]="chartTypeTrasaction"
                  [legend]="legendActivation"
                  [colors]="colorsTrand"
                  (chartClick)="onTableClick($event)">
          </canvas>
        </div>
      </div>
    </div>

    <div class=" col-md-6 col-xl-6">
      <div class="col-12 card-box tilebox-one" *ngIf="merchantBillingTopSelected?.length > 0">
        <div class=" col-md-12" style="padding:0px;margin:0px;">
          <table class="table table-striped" (click)="onTableClick($event)">
            <thead>
              <tr>
                <th>CardAcceptor</th>
                <th>MerchantName</th>
                <th>Transaction</th>
                <th style="width: 130px;">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr scope="col" *ngFor="let s of highestMerchantBillingReport">
                <td>{{s.cardAcceptor}}</td>
                <td>{{s.merchantName}}</td>
                <td [style.background-color]="bgTransCountColor">{{ s.transaction }}</td>
                <td [style.background-color]="bgTransAmountColor">R {{ s.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
